// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"02b3d67f","335":"e3fd2ec8","787":"3a8ed696"}[chunkId] + ".chunk.js";
};